// extracted by mini-css-extract-plugin
export default {"container":"VersionInfo_container__zYcjR"};